<template>
    <div class="selectable-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="mergedOptions"
            ref='table'
        >
            <label class="radio-button" slot="radio" slot-scope="props" v-if="type == 'radio'">
                <input type="radio"
                    :value="selected"
                    :checked="selected == props.row.id"
                >
                <span class="radio-button__checkmark"></span>
            </label>


            <label class="checkbox" slot="checkbox" slot-scope="props" v-if="type == 'checkbox'">
                <input
                    type="checkbox"
                    :value="props.row.id"
                    v-model="checked"
                />
                <div class="checkbox__fake-box">
                    <img src="/images/icons/success.svg" alt="Success checkmark">
                </div>
            </label>

            <template v-for="slot in Object.keys($scopedSlots)"
                :slot="slot"
                slot-scope="props">
                <slot :name="slot" v-bind="props"/>
            </template>

        </v-client-table>
    </div>
</template>

<script>
    import { Event } from 'vue-tables-2';
    import { EventBus } from '../eventbus.js';

    export default {
        props: [
            'options',
            'tableDataRoute',
            'customColumns',
            'type'
        ],

        components: {},

        data() {
            return {
                tableData: [],

                columns: [this.type, ...this.customColumns],

                defaultOptions: {
                    rowClassCallback: (row) => {
                        if (this.type == 'radio' && row.id == this.selected) {
                            return 'selected'
                        }
                        if (this.type == 'checkbox' && this.checked.indexOf(row.id) != -1) {
                            return 'selected';
                        }
                    },
                },

                selected: null,

                checked:[]
            }
        },

        computed: {
            mergedOptions() {
                return Object.assign(this.options, this.defaultOptions);
            },
        },

        methods: {
            /**
             * Set selected id by row clicking
             */
            setId(e) {
                if (this.type == 'radio') {
                    this.selected = e.row.id
                }

                // setTimeout to solve the aysnc problem by checked.
                if (this.type=="checkbox") {
                    setTimeout(() => {
                        if(this.checked.includes(e.row.id)) {
                            this.checked = this.checked.filter(v => v !== e.row.id)
                        } else {
                            this.checked.push(e.row.id)
                        }
                    }, 0);
                }

                setTimeout(() => {
                    // Send selected resource id to other components
                    EventBus.$emit('selected', this.selected || this.checked);
                    EventBus.$emit('showNextButton');
                }, 0);
            }
        },

        created() {
            Event.$on('vue-tables.row-click', e => this.setId(e));

            /**
            * Ajax-Call to get data asJSON to fill the table.
            */
            axios
                .get(this.tableDataRoute)
                .then(response => {
                    if (response.data instanceof Array) {
                        this.tableData = response.data;
                    } else {
                        this.tableData = response.data.data;
                    }

                    /**
                    * when the site is loading it will show the message "loading files" and after loading it will
                    * replaced with "no entries found" message because while loading files the table shows the
                    * message "no entries found".
                    */
                    this.options.texts.noResults = this.trans('vuetables.label.noResults');
                });
        },

        mounted() {
            var filter = this.debounce((query) => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
        },
    }
</script>
